const infoModal = document.querySelector('#frontpage-info-modal');

if (infoModal) {
    // Get the button that closes the modal
    const closeBtn = infoModal.querySelector('.modal__close-btn');

    // Add click event listener to the button if defined
    if (closeBtn) {
        closeBtn.addEventListener('click', () => {
            document.body.classList.remove('overflow-hidden'); // Enable scrolling
            infoModal.classList.add('modal--closing'); // Trigger closing animation

            // Hide modal after animation is done
            setTimeout(() => {
                infoModal.classList.remove('modal--closing');
                infoModal.setAttribute('aria-hidden', 'true');
            }, 250);
        });
    }
}